import { BrandSwoosh } from "./BrandSwoosh"

export function Hero() {
  return (
    <section id="top" className="relative overflow-hidden px-5 pb-14 pt-12 text-center md:px-8 md:pb-[88px] md:pt-24">
      {/* Original-SINUS-Schwunglinien, rein dekorativ. */}
      <BrandSwoosh className="pointer-events-none absolute left-1/2 top-[190px] w-[760px] max-w-[124%] -translate-x-1/2 -translate-y-1/2 md:top-[222px] md:w-[1000px]" />

      <div className="relative z-10 mx-auto w-full max-w-content">
        <h1 className="font-display mx-auto max-w-[700px] text-hero-sm font-medium md:text-hero">
          Lizenzen &amp; Pakete zu den Sinus-Milieus
          <sup className="align-super text-base md:text-[26px]">®</sup>
        </h1>
        <p className="ml-auto mt-14 max-w-[520px] text-left text-sm text-brand-muted md:mt-[132px] md:text-base">
          Wählen Sie Ihre Produkte und schließen Sie den Kauf sicher ab. Die Freischaltung erfolgt
          automatisch, Ihre Zugangsdaten erhalten Sie im Anschluss per E-Mail.
        </p>
      </div>
    </section>
  )
}
